import React from "react";
import { Form } from "react-bootstrap";

const TextInputFormik = ({
  formik,
  field,
  maxLength,
  type,
  placeholder,
  evento,
  disabled,
  onlyPositive = false,
  onlyInteger = false,
}) => {
  const handleChange = (e) => {
    const value = e.target.value;

    // Permitir valor vazio
    if (value === "") {
      formik.setFieldValue(field, value);
      return;
    }

    // Se nenhuma restrição numérica, aceitar qualquer valor (incluindo letras)
    if (!onlyPositive && !onlyInteger) {
      formik.setFieldValue(field, value);
      return;
    }

    // Regex de validação dinâmica
    const isValid = (() => {
      if (onlyInteger && onlyPositive) return /^\d+$/; // somente inteiros positivos
      if (onlyInteger && !onlyPositive) return /^-?\d+$/; // inteiros positivos e negativos
      if (!onlyInteger && onlyPositive) return /^\d*\.?\d+$/; // decimais positivos
      return /^-?\d*\.?\d+$/; // decimais positivos e negativos
    })();

    if (isValid.test(value)) {
      formik.setFieldValue(field, value);
    }
  };

  return (
    <>
      <Form.Control
        id={field}
        name={field}
        maxLength={maxLength}
        type={type}
        disabled={formik.isSubmitting || disabled}
        value={formik.values[field]}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={evento}
        isInvalid={formik.touched[field] && formik.errors[field]}
        autoComplete="off"
        min={onlyPositive ? "0" : undefined}
        step={onlyInteger ? "1" : "any"}
      />
      {(formik.touched[field] || formik.dirty) && formik.errors[field] && (
        <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
      )}
    </>
  );
};

export default TextInputFormik;
